import { TranslateService } from '@ngx-translate/core';
import { MuiI18nProvider } from '@move/ui';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';


@Injectable()
export class MuiI18nProviderImpl extends MuiI18nProvider {
  constructor(private _translate: TranslateService) {
    super();
  }

  alert(): Observable<{ closeButton: string }> {
    return this._translate.get('mui.alert.closeButton').pipe(map((t) => ({ closeButton: t })));
  }

  breadcrumbs(): Observable<{ label: string }> {
    return this._translate.get('mui.breadcrumbs.label').pipe(map((t) => ({ label: t })));
  }

  carousel(): Observable<{ nextButton: string, previousButton: string }> {
    return this._translate.get([
      'mui.carousel.nextButton',
      'mui.carousel.previousButton'
    ]).pipe(map((t) => ({
      nextButton: t['mui.carousel.nextButton'],
      previousButton: t['mui.carousel.previousButton']
    })));
  }

  chip(): Observable<{ dismissButton: string }> {
    return this._translate.get('mui.chip.dismissButton').pipe(map((t) => ({ dismissButton: t })));
  }

  datepicker(): Observable<{
    calendarWeekLabel: string; clearButton: string; placeholderChars: {
      year: string;
      month: string;
      day: string;
    }
  }> {
    return this._translate.get([
      'mui.datepicker.calendarWeekLabel',
      'mui.datepicker.clearButton',
      'mui.datepicker.placeholderChars.year',
      'mui.datepicker.placeholderChars.month',
      'mui.datepicker.placeholderChars.day'
    ]).pipe(map((t) => ({
        calendarWeekLabel: t['mui.datepicker.calendarWeekLabel'],
        clearButton: t['mui.datepicker.clearButton'],
        placeholderChars: {
          year: t['mui.datepicker.placeholderChars.year'],
          month: t['mui.datepicker.placeholderChars.month'],
          day: t['mui.datepicker.placeholderChars.day']
        }
      })
    ));
  };

  fileInput(): Observable<{
    selectButton: string;
    dropzoneLabel: string;
  }> {
    return this._translate.get([
      'mui.fileInput.browseButton',
      'mui.fileInput.dropzoneLabel'
    ]).pipe(map((t) => ({
      selectButton: t['mui.fileInput.browseButton'],
      dropzoneLabel: t['mui.fileInput.dropzoneLabel'],
    })));
  }

  modal(): Observable<{ basicConfirmButton: string, basicDismissButton: string, closeButton: string }> {
    return this._translate.get([
      'mui.modal.basicConfirmButton',
      'mui.modal.basicDismissButton',
      'mui.modal.closeButton'
    ]).pipe(map((t) => ({
      basicConfirmButton: t['mui.modal.basicConfirmButton'],
      basicDismissButton: t['mui.modal.basicDismissButton'],
      closeButton: t['mui.modal.closeButton']
    })));
  }

  pagination(from: number, to: number, total: number): Observable<{
    displayedItemsLabel: string;
    nextPageButton: string;
    previousPageButton: string;
    sizeSelectLabel: string
  }> {
    return this._translate.get([
      'mui.pagination.nextPageButton',
      'mui.pagination.previousPageButton',
      'mui.pagination.sizeSelectLabel',
      'mui.pagination.displayedItemsLabel'
    ], { from, to, total }).pipe(map((t) => ({
        displayedItemsLabel: t['mui.pagination.displayedItemsLabel'],
        nextPageButton: t['mui.pagination.nextPageButton'],
        previousPageButton: t['mui.pagination.previousPageButton'],
        sizeSelectLabel: t['mui.pagination.sizeSelectLabel']
      })
    ));
  }

  password(): Observable<{ showPasswordButton: string, hidePasswordButton: string }> {
    return this._translate.get([
      'mui.password.showPasswordButton',
      'mui.password.hidePasswordButton'
    ]).pipe(map((t) => ({
      showPasswordButton: t['mui.password.showPasswordButton'],
      hidePasswordButton: t['mui.password.hidePasswordButton']
    })));
  }
}
